import { fromJS } from 'immutable';
import { isImmutable } from '../helpers/immutableHelpers';
import {
  SET_COURSEWARE_ITEM,
  SET_IN_COURSEWARE_ITEM,
} from './constants/actions';

const initialState = fromJS({});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COURSEWARE_ITEM:
      return state.setIn(
        [action.id],
        isImmutable(action.data) ? action.data : fromJS(action.data),
      );
    case SET_IN_COURSEWARE_ITEM:
      return state.setIn(
        [action.activityId || action.id, ...action.keyPath],
        isImmutable(action.data) ? action.data : fromJS(action.data),
      );
    default:
      return state;
  }
};

export default reducer;
